// const $ = jQuery.noConflict(true); // lokale $ variabele, veilig naast WordPress jQuery

export const clickOutsideMenu = {
  init($) {
    // just make sure it is there
    if ($('.menu-click-outside').length > 0) {
      $('.menu-click-outside').on('click', (e) => {
        e.preventDefault();

        // close mobile menu
        if ($(window).width() < 980) {
          $('.menu-toggle')[0].click();
        }
      });
    }
  }
};
